import { CheckSquareOutlined, CommentOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { features } from '@/lib/features';
import { useFeature } from '@/lib/useFeature';
import { navItem } from './navItem';

/**
 * Messages and Tasks, for whichever shell the person is in — every shell,
 * because everyone is an employee first (COLLABORATION-PLAN.md §3.1). Empty
 * when the workspace has not switched Collaboration on.
 */
export function useCollaborationNav(base: '/ess' | '/mss' | '/admin') {
  const { t } = useTranslation('collaboration');
  const enabled = useFeature(features.collaboration);
  if (!enabled) return [];
  return [
    navItem(`${base}/messages`, t('nav.messages'), <CommentOutlined />),
    navItem(`${base}/tasks`, t('nav.tasks'), <CheckSquareOutlined />),
  ];
}
